import { render, staticRenderFns } from "./ClientRecordsUpload.vue?vue&type=template&id=27f89490&scoped=true"
import script from "./ClientRecordsUpload.vue?vue&type=script&lang=js"
export * from "./ClientRecordsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f89490",
  null
  
)

export default component.exports